import { CardTextModel } from "@models/card-text.model";
import { BaseConverter } from "./base.converter";
import { CardTextDto } from "@dtos/card-text.dto";

export class CardTextConverter extends BaseConverter <CardTextModel,CardTextDto> {

    modelToDto(model: CardTextModel): CardTextDto {
        return new CardTextDto(model.textDetail, model.parentIdCard);
    }

    dtoToModel(dto: CardTextDto): CardTextModel {
        return new CardTextModel(dto.textDetail, dto.cardInfo.id);
    }
    
}